import React from 'react';
import { CloseButtonContainer } from './closeButton.style';
import { CloseButtonProps } from './closeButton.types';
import { ButtonSizes } from '../../Button/button.types';

const DEFAULT_DATA_ATTR = { 'data-testid': 'modal__close-button' };

const CloseButton = ({ dataAttr = {}, iconName = 'close', size = ButtonSizes.LARGE, ...props }: CloseButtonProps) => {
  const combinedDataAttr = { ...DEFAULT_DATA_ATTR, ...dataAttr };
  return <CloseButtonContainer dataAttr={combinedDataAttr} iconName={iconName} size={size} {...props} />;
};

export default React.memo(CloseButton);
